import { InjectionToken } from '@angular/core';

export const GATEWAY_CONFIG = new InjectionToken(
  'EVERNORTH_MEMBER_GATEWAY_CONFIG',
);
export interface GatewayConfig {
  cdn: string;
  resourceContent: string;
  gsg: string;
  thirdPartyVendors: string;
  thirdPartyVendorsCdn: string;
  dashboard: string;
  directory: string;
  directoryProviders: string;
  directoryProfile: string;
  directoryTelehealth: string;
  directoryReport: string;
  directoryGeolocation: string;
  directoryRedirect: string;
  providerReviews: string;
  navigation: string;
  authguards: string;
  member: string;
  registration: string;
  directoryTypeahead: string;
  claimsIntake: string;
  customerProfile: string;
  disabilityIntakeState: string;
  inviteOthers: string;
  communicationPreferencesUrl: string;
  elevateSurvey: string;
  accountRecovery: string;
  profileSettings: string;
  navigationprofile: string;
  kanaForm: string;
  coverageGuardScopes: string;
  productgroups: string;
  productsummaries: string;
  behavioralbenefits: string;
  eapbenefits: string;
  wellness: string;
  claimUserProfile: string;
  claims: string;
  claimsEob: string;
}

export enum ApiVersion {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}
